module.exports = __webpack_public_path__ + "static/img/Sex-Toys-for-Men-nav-tile-900x1200.8ece6a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/fenlei/Sex-Toys-for-Men-nav-tile-900x1200.jpg
// module id = qM0f
// module chunks = 0